module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"needHelp":"Need help? Customer Service"},"de":{"needHelp":"Brauchen Sie Hilfe? Kundenservice"}}')
  delete Component.options._Ctor
}
